import { Layout } from "@clerk/types";
import { Theme } from "@mui/material";

export function getClerkLayout(muiTheme: Theme): Layout {
  return {
    logoImageUrl:
      muiTheme.palette.mode === "dark"
        ? "/lancedb-logo-dark.svg"
        : "/lancedb-logo-light.svg",
    termsPageUrl:
      "https://242023405.fs1.hubspotusercontent-na2.net/hubfs/242023405/Website%20Documentation/terms.pdf",
    privacyPageUrl:
      "https://242023405.fs1.hubspotusercontent-na2.net/hubfs/242023405/Website%20Documentation/privacy.pdf",
    helpPageUrl: "mailto:support@lancedb.com",
  };
}
